const startWithVowel = v => {
  if (v.match(/[aeiouAEIOU]/)) {
    return 'an';
  }
  return 'a';
};

export default startWithVowel;
